import React = require("react");
import DropdownTreeSelect from "react-dropdown-tree-select";
import "./HierarchySelect.scss";

export interface HierarchyNode {
    key: string;
    value: string;
    label: string;
    children: HierarchyNode[];
    hierarchyGuid: string;
    disabled: boolean;
}

interface HierarchySelectProps {
    onChange: () => any;
    hierarchyNodes: HierarchyNode[];
    placeholderText: string;
    noMatchesText: string;
    render: boolean;
    defaultValues?: string[];
}

export class HierarchySelect extends React.Component<HierarchySelectProps, {}> {
    constructor(props: HierarchySelectProps) {
        super(props);
    }

    public shouldComponentUpdate(nextProps: HierarchySelectProps, nextState: {}): boolean {
        return nextProps.render;
    }

    public render() {

        const processed = (this.props.defaultValues || []).length > 0
            ? this.props.hierarchyNodes.map((x) => {
                return this.highlightDefault(this.props.defaultValues, x);
            })
            : this.props.hierarchyNodes;

        return (
            <DropdownTreeSelect
                className="hierarchy-filter__select"
                data={processed}
                onChange={this.props.onChange}
                clearSearchOnChange={false}
                showPartiallySelected={true}
            />
        );
    }

    private highlightDefault = (defaultValues: string[], node: HierarchyNode, forChildren: boolean = false) => {
        return {
            ...node,
            // isDefaultValue: defaultValues.indexOf(node.value) > -1,
            expanded: defaultValues.indexOf(node.value) > -1 || forChildren,
            checked: defaultValues.indexOf(node.value) > -1 || forChildren,
            children: node.children.map((x) => this.highlightDefault(
                defaultValues,
                x,
                defaultValues.indexOf(node.value) > -1 || forChildren),
            ),
        };
    }
}
